import React from "react";
import { PageHeader } from "@velocity-ehs/component-library";
import MetadataForm, { Mode } from "./MetadataForm";
import { useTranslation } from "react-i18next";
import VerticalTabs from "../../sharedComponents/VerticalTabs";
import { useHistory } from "react-router";
import { useForm } from "react-hook-form";
import { MetadataFormValues } from "./Metadata";

const AddMetadata: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const formMethods = useForm<MetadataFormValues>({
    mode: "onBlur",
  });

  return (
    <>
      <PageHeader
        title={t("action_add_single_sign_on")}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          {
            text: t("universal_Single_Sign_On"),
            href: "/singleSignOn",
          },
          {
            text: t("universal_Add"),
            href: "",
          },
        ]}
        primaryButton={{
          loading: formMethods.formState.isSubmitting,
          type: "submit",
          form: "singleSignOnForm",
          label: t("universal_Save"),
        }}
        secondaryButton={{
          type: "button",
          label: t("universal_Cancel"),
          className: "p-button-text",
          onClick: () => history.push("/singleSignOn"),
        }}
      />
      <VerticalTabs
        tabs={[
          {
            content: (
              //@ts-ignore
              <MetadataForm
                onSaveChanges={() => history.push("/singleSignOn")}
                mode={Mode.Add}
                formMethods={formMethods}
              />
            ),
            title: t("action_add_single_sign_on"),
          },
        ]}
      />
    </>
  );
};

export default AddMetadata;
